import type { InterviewEventCount, InterviewEventCountParams } from '@core/dashboard-types';
import type { PickActions } from '@core/ngrx-legacy';
import { createEntityCollectionStore, getEntityCollectionActions } from '@core/ngrx-legacy';

const idSelector = (item: { id: string }) => item.id;
const { namespace, actions, reducer, selectors } =
  createEntityCollectionStore<InterviewEventCount>()('InterviewEventCountWidget', {
    idSelector,
    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, idSelector);
      return {
        fetchOne: (state, payload: { id: string; params: InterviewEventCountParams }) =>
          defaultActions.fetchOne(state, {
            ...payload,
            id: payload.id,
          }),
      };
    },
  });

export const InterviewEventCountWidgetActions: PickActions<typeof actions, 'fetchOne'> = actions;

export {
  namespace as InterviewEventCountWidgetNamespace,
  reducer as InterviewEventCountWidgetReducer,
  selectors as InterviewEventCountWidgetSelectors,
};
